import React from 'react'
import styles from './styles.module.scss'
import DiscountCode from '../DiscountCode'

type DiscountCodeProps = {
  amount: string | 0 | undefined
  code: string
}

const DiscountCodeWrapper = ({ amount, code }: DiscountCodeProps) => (
  <div className={styles.DiscountCode} data-testid="cart-discount-code">
    <div className={styles.DiscountCode__line}>
      <div className={styles.DiscountCode__title}>
        <p className={styles.DiscountCode__text}>
          Discount{' '}
          <DiscountCode code={code} />
        </p>
        <p className={styles.DiscountCode__subtext}>
          (Other discounts will be overridden)
        </p>
      </div>
      {!!amount && <p className={`${styles.DiscountCode__price}`}>-{amount}</p>}
    </div>
  </div>
)

export default DiscountCodeWrapper
